import { tourCopy } from '../copy';
import { TOUR } from '../targets';
import type { TourDefinition } from '../tourTypes';

const c = tourCopy.hiring;
const myGigs = (tab: string) => `/profile/my-gigs?tab=${tab}`;

export const hiringTour: TourDefinition = {
  id: 'hiring',
  version: 1,
  title: c.title,
  description: c.description,
  route: '/profile/my-gigs',
  steps: [
    { ...c.tabs, target: TOUR.myGigsTabs, placement: 'bottom', route: '/profile/my-gigs' },
    { ...c.inquiries, target: TOUR.myGigsTabInquiries, placement: 'bottom' },
    {
      ...c.applicants,
      target: TOUR.myGigsTabApplicants,
      placement: 'bottom',
      route: myGigs('applicants'),
    },
    // Only shown when an applicant is open in the detail panel.
    { ...c.applicantActions, target: TOUR.applicantActions, placement: 'top', optional: true },
    { ...c.offers, target: TOUR.myGigsTabOffers, placement: 'bottom', route: myGigs('offers') },
    { ...c.createOffer, target: TOUR.myGigsCreateOffer, placement: 'bottom', optional: true },
    {
      ...c.payments,
      target: TOUR.myGigsTabPayments,
      placement: 'bottom',
      route: myGigs('payment_history'),
    },
  ],
};
